var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"#","show-file-list":false,"http-request":_vm.uploadFn,"before-upload":_vm.beforeAvatarUpload}},[(_vm.imageUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon",attrs:{"color":"red"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }